var map = {
	"./dupdep": 5,
	"./dupdep.js": 5
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;



/*****************
 ** WEBPACK FOOTER
 ** ./compile/deduplication/dedupe1 ^\.\/dupd.*$
 ** module id = 3
 ** module chunks = 0
 **/